import { FC } from "react";
import { createPortal } from "react-dom";
import { EyeIcon, EyeOffIcon, XIcon } from "@heroicons/react/outline";
import { RiCheckDoubleFill } from "@remixicon/react";

interface ErrorLogsBulkActionsBarProps {
  selectedCount: number;
  onHide: () => void;
  onUnhide?: () => void;
  onClose: () => void;
  onSelectAll: () => void;
  hasHiddenSelected?: boolean;
}

const ErrorLogsBulkActionsBar: FC<ErrorLogsBulkActionsBarProps> = ({
  selectedCount,
  onHide,
  onUnhide,
  onClose,
  onSelectAll,
  hasHiddenSelected = false,
}) => {
  if (!selectedCount) return null;

  // Determine which action to show based on whether hidden items are selected
  const showUnhide = hasHiddenSelected && onUnhide;
  const hideAction = showUnhide ? onUnhide : onHide;
  const HideIcon = showUnhide ? EyeIcon : EyeOffIcon;
  const hideText = showUnhide ? "UNHIDE" : "HIDE";

  return createPortal(
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 flex items-center justify-between gap-4 px-4 py-3 min-w-[400px]">
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-2 px-3 py-1 rounded">
            <span className="text-sm font-medium text-gray-700">
              {selectedCount} selected
            </span>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors p-1 hover:bg-gray-100 rounded"
              aria-label="Clear selection"
            >
              <XIcon className="w-5 h-5" />
            </button>
          </div>
          <button
            onClick={onSelectAll}
            className="text-rebrandBlue-600 hover:text-rebrandBlue-700 p-2 rounded hover:bg-rebrandBlue-50 transition-colors"
            aria-label="Select all"
          >
            <RiCheckDoubleFill className="w-5 h-5" />
          </button>
        </div>

        <button
          onClick={hideAction}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white rounded-md transition-colors bg-red-600 hover:bg-red-700"
        >
          <HideIcon className="w-4 h-4" />
          {hideText}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default ErrorLogsBulkActionsBar;
